module.exports = __webpack_public_path__ + "img/mobileScreen-alertIcon.41c2e5a0.svg";